const initialState = {
  translations: {},
  cities: {},
  filters: {},
  moreFilters: {},
  banner: [],
};

const parseTranslation = (translations) => {
  // New API can return an array of rows:
  // [{ translation, key: { key_name }, language: { code } }, ...]
  if (Array.isArray(translations)) {
    return translations.reduce((acc, row) => {
      const keyName = row?.key?.key_name;
      const langCode = row?.language?.code;
      if (!keyName || !langCode) {
        return acc;
      }

      if (!acc[keyName]) {
        acc[keyName] = { key: keyName };
      }

      const value = typeof row?.translation === "string" ? row.translation : "";
      if (langCode === "sr") {
        acc[keyName][langCode] = value
          .replace("&Scaron;", "Š")
          .replace("&scaron;", "š");
      } else {
        acc[keyName][langCode] = value;
      }

      return acc;
    }, {});
  }

  if (!translations || typeof translations !== "object") {
    return {};
  }

  return Object.keys(translations).reduce((acc, val) => {
    const srValue =
      translations[val] && typeof translations[val]["sr"] === "string"
        ? translations[val]["sr"]
        : "";
    acc[val] = {
      ...(translations[val] || {}),
      sr: srValue.replace("&Scaron;", "Š").replace("&scaron;", "š"),
    };
    return acc;
  }, {});
};

const convertToSorted = (cities) => {
  if (!cities || typeof cities !== "object") {
    return {};
  }

  const mappedCities = Object.keys(cities).map((city) => ({
    name: city,
    ...(cities[city] || {}),
    areasAndStreets: Array.isArray(cities[city]?.areasAndStreets)
      ? cities[city].areasAndStreets
      : [],
  }));
  mappedCities.sort((first, second) => {
    const secondLen = Array.isArray(second.areasAndStreets)
      ? second.areasAndStreets.length
      : 0;
    const firstLen = Array.isArray(first.areasAndStreets)
      ? first.areasAndStreets.length
      : 0;
    return secondLen - firstLen;
  });

  return mappedCities.reduce((acc, city) => {
    acc[city.name] = city;
    return acc;
  }, {});
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case "SET_BANNER":
      return {
        ...state,
        banner: action.payload,
      };
    case "FETCH_FILTERS":
      return {
        ...state,
        filters: action.payload,
        moreFilters: action.moreFilters,
      };
    case "FETCH_CITIES":
      return {
        ...state,
        cities: convertToSorted(action.payload),
      };
    case "FETCH_TRANSLATIONS":
      return {
        ...state,
        translations: parseTranslation(action.payload),
      };
    default:
      return state;
  }
};
